import React from 'react';

const TeacherIllustration = () => (
  <svg width="546" height="509" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M221.73 1.215C365.839 15.78 485.119 120.728 537.383 254.5c52.265 133.773-144.513 247.727-286.244 254.255C109.409 515.284 0 390.121 0 247.558S77.62-13.349 221.73 1.215z"
      fill="#EEFBF6"
    />
    <path
      d="M462.043 291.291s1.103 1.834 4.08 2.85c1.045.357 2.136.565 3.239.618a18.211 18.211 0 004.746-.32s7.079-30.018 24.504-47.424c17.424-17.406 40.801-41.626 31.82-59.515-8.981-17.889-34.842-3.025-50.468 29.29-15.639 32.313-17.921 74.501-17.921 74.501z"
      fill="#1ABD7D"
    />
    <path
      d="M466.124 294.14c1.045.358 2.136.566 3.239.619 9.938-53.975 44.653-88.614 45.005-88.965a1.65 1.65 0 00-2.308-2.354c-.364.349-35.8 35.663-45.936 90.7z"
      fill="#fff"
    />
    <path
      d="M433.226 232.348c16.324 53 11.623 63.044 11.623 63.044l3.878.307 3.296.268 4.702.374c7.781-19.589 14.551-109.201-13.165-116.431-28.216-7.36-15.898 34.394-10.334 52.438z"
      fill="#1ABD7D"
    />
    <path
      d="M441.139 206.367c.149.517 12.79 48.849 7.589 89.331l3.295.268c5.228-41.148-7.547-89.923-7.683-90.446a1.655 1.655 0 00-3.201.848v-.001z"
      fill="#fff"
    />
    <path
      d="M473.309 298.551l3.02 1.72 2.89 1.652 1.732.987c-.012-.435 2.316-3.558 29.095-24.914 11.06-8.828 40.625-32.619 21.867-42.8-17.207-9.333-55.151 47.936-58.604 63.355z"
      fill="#1ABD7D"
    />
    <path
      d="M476.33 300.271l2.889 1.652c12.397-24.072 43.827-49.389 44.17-49.663a1.651 1.651 0 10-2.068-2.575c-1.384 1.117-32.272 25.972-44.991 50.586z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M271.488 249.017s-80.67-5.263-138 14.065c-57.33 19.327-71.382 3.168-96.677 16.167-25.294 12.998-45.426 88.366 54.225 103.556 99.65 15.189 90.165 68.586 159.022 78.774 68.856 10.188 117.338-19.322 151.415-37.239 34.077-17.916 30.213-14.905 76.938-38.017 46.724-23.112 54.804-105.669-20.377-94.076-75.18 11.593-51.642-46.41-186.546-43.23z"
      fill="#68DCAF"
    />
    <path
      d="M90.431 322.848c13.416 0 24.291-3.528 24.291-7.882 0-4.353-10.875-7.882-24.29-7.882-13.416 0-24.291 3.529-24.291 7.882 0 4.354 10.875 7.882 24.29 7.882z"
      fill="#499D75"
    />
    <path
      d="M102.445 318.548c20.051 0 36.305-5.522 36.305-12.333s-16.254-12.332-36.305-12.332c-20.05 0-36.304 5.521-36.304 12.332 0 6.811 16.254 12.333 36.304 12.333z"
      fill="#499D75"
    />
    <path
      d="M123.263 315.112c5.044-.827 8.433-5.759 7.571-11.016-.863-5.257-5.65-8.848-10.693-8.021-5.044.828-8.433 5.76-7.571 11.017.863 5.257 5.65 8.847 10.693 8.02z"
      fill="#129F72"
    />
    <path
      d="M108.781 307.042l-5.621-5.779a9.843 9.843 0 011.447-14.942c2.811-1.926 7.94-3.154 11.01-1.675 5.88 2.831 13.283 9.612 15.238 19.585l-22.074 2.811z"
      fill="#129F72"
    />
    <path
      d="M89.106 307.363a10.248 10.248 0 00-5.766.264c-1.958.64-4.947 1.299-6.269-.056-2.051-2.107-5.422-8.42-7.728-7.093-2.307 1.326 1.292 16.578 4.545 18.924 3.252 2.347 14.157-1.889 14.872-2.48.627-.519 7.387-7.698.346-9.559z"
      fill="#55312F"
    />
    <path
      d="M123.169 293.458s-32.873 13.113-42.678 14.128l3 11.322s24.887 1.212 41.257-4.175l-1.579-21.275z"
      fill="#129F72"
    />
    <path
      d="M99.114 298.307s21.248 1.237 22.588-.926c1.341-2.164 4.887-4.055 5.252-3.347.366.707-.404 18.537-27.84 4.273zM118.311 311.953s-29.154 11.631-36.771 2.576l36.771-2.576z"
      fill="#037A4A"
    />
    <path
      d="M78.919 314.91c5.11 0 9.254-4.318 9.254-9.646 0-5.327-4.143-9.645-9.254-9.645-5.11 0-9.254 4.318-9.254 9.645 0 5.328 4.143 9.646 9.254 9.646z"
      fill="#129F72"
    />
    <path
      d="M91.902 304.6l4.61-6.612a9.844 9.844 0 00-3.847-14.512 9.484 9.484 0 00-9.483.808c-5.345 3.747-13.204 10.957-13.519 21.116l22.24-.8z"
      fill="#129F72"
    />
    <path
      d="M94.565 296.183c-17.595-.849-28.492-19.697-20.868-35.579 4.085-8.51 11.769-17.561 25.982-17.624 26.862-.12 28.787 24.779 27.328 35.956-1.009 7.732-14.046 18.135-32.442 17.247z"
      fill="#3778F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.224 247.815a1.657 1.657 0 11.006-3.315 1.657 1.657 0 01-.007 3.315zm0 0h.003-.004zm8.919 6.939c-.024-.001-.048-.002-.071-.006l-.043.003-.062.003a1.658 1.658 0 010-3.317c.024 0 .048.002.072.006l.058-.004.046-.002a1.658 1.658 0 110 3.317zm20.201.208l-.377-.123a1.65 1.65 0 01-1.147-1.57 1.23 1.23 0 01.012-.148l.053-.429.225.321c.36.516.708 1.057 1.032 1.608l.202.341zm-29.905 5.63a1.66 1.66 0 01-1.173-2.831 1.658 1.658 0 112.344 2.348 1.664 1.664 0 01-1.174.486l.003-.003zm20.244.177a1.66 1.66 0 111.171-.484 1.664 1.664 0 01-1.175.486l.004-.002zm-9.75 5.806a1.66 1.66 0 01-1.658-1.658c0-.023.002-.046.006-.068v-.04a.382.382 0 01-.006-.068 1.659 1.659 0 013.317 0 .382.382 0 01-.006.068v.04a.382.382 0 01.006.068 1.662 1.662 0 01-1.663 1.66l.004-.002zm20.507 0a1.658 1.658 0 111.172-.483 1.661 1.661 0 01-1.176.485l.004-.002zm-9.793 5.841a1.658 1.658 0 111.171-.484 1.662 1.662 0 01-1.174.485l.003-.001zm-11.504 4.006h-.003a1.925 1.925 0 001.746-1.834 1.66 1.66 0 00-1.658-1.658c-.957.091-1.7.873-1.743 1.833a1.66 1.66 0 001.655 1.659h.003zm20.596-.001a1.657 1.657 0 11.634-3.19 1.657 1.657 0 01.537 2.706 1.656 1.656 0 01-1.174.485l.003-.001zm-50.04 5.806l-.056-.116c-.427-.907-.8-1.838-1.118-2.789l-.04-.121.113-.059c.235-.128.499-.195.767-.196a1.653 1.653 0 01.455 3.245l-.12.036zm40.244.037a1.658 1.658 0 11.002-3.314 1.658 1.658 0 01-.002 3.313v.001zm-30.22 5.92a1.658 1.658 0 110-3.315 1.658 1.658 0 010 3.315zm19.981.003a1.657 1.657 0 110-3.31 1.657 1.657 0 010 3.308v.002zm-9.705 5.839a1.658 1.658 0 110-3.316 1.658 1.658 0 010 3.316zm8.059 1.851l.023.199.151-.019a42.83 42.83 0 002.98-.472l.147-.029-.029-.147a1.658 1.658 0 00-3.283.327c.001.047.004.094.011.141zm.288-.141a1.36 1.36 0 011.358-1.358c.59.001 1.112.382 1.293.943-.867.167-1.758.308-2.651.42v-.005zm-9.602-3.887a1.357 1.357 0 112.508 1.038 1.357 1.357 0 01-2.508-1.038zm20.175 1.41l-.054-.149a1.648 1.648 0 011.554-2.222 1.643 1.643 0 011.417.807l.081.136-.14.073c-.883.468-1.796.903-2.712 1.293l-.146.062zm.142-.713a1.36 1.36 0 011.358-1.358v-.001c.42-.001.817.195 1.07.53-.78.408-1.582.791-2.389 1.138a1.24 1.24 0 01-.039-.309zm-10.714-6.016c0-.75.607-1.359 1.357-1.359v-.001a1.36 1.36 0 01.001 2.717c-.75 0-1.358-.607-1.358-1.357zm-19.982-.004c0-.75.608-1.358 1.358-1.358v.002a1.358 1.358 0 11-1.358 1.356zm40.19.545v-.369a1.647 1.647 0 011.507-1.643l.359-.033-.23.278c-.423.511-.886 1.02-1.38 1.513l-.256.254zm.368-.798c.121-.36.388-.653.736-.805v.001a20.4 20.4 0 01-.736.804zm-10.235-6.187a1.36 1.36 0 112.509 1.041 1.36 1.36 0 01-2.509-1.041zm-19.253 2.178a1.658 1.658 0 110-3.314 1.658 1.658 0 010 3.313v.001zm-1.255-2.178c.21-.508.706-.839 1.255-.839a1.358 1.358 0 11-1.255.839zm-18.318 1.776a25.22 25.22 0 01-1.006-2.509l-.003.001c.163-.071.339-.108.516-.109a1.354 1.354 0 01.493 2.617zm48.52-7.099a1.357 1.357 0 011.357-1.358l-.003.001a1.358 1.358 0 11-1.354 1.357zm-20.411-.675c.203-.519.703-.86 1.26-.858l-.003.002a1.36 1.36 0 011.362 1.356 1.34 1.34 0 01-.178.657l-.008.018c-.203.519-.703.86-1.26.858a1.35 1.35 0 01-1.173-2.033zm-18.808 2.333a1.658 1.658 0 111.17-.484 1.658 1.658 0 01-1.174.485l.004-.001zm-1.358-1.658c0-.75.608-1.358 1.358-1.358l-.004.001a1.358 1.358 0 11-1.354 1.357zm31.485-4.005c0-.75.608-1.358 1.357-1.358l-.003.002a1.357 1.357 0 11-1.354 1.356zm-19.063 1.658a1.657 1.657 0 111.171-.484 1.658 1.658 0 01-1.174.485l.003-.001zm-1.356-1.658c0-.75.606-1.358 1.356-1.358l-.003.002a1.357 1.357 0 11-1.353 1.356zm-18.712 1.658a1.657 1.657 0 111.17-.484 1.662 1.662 0 01-1.173.485l.003-.001zm-1.258-2.182a1.358 1.358 0 011.258-.834l-.004.002a1.356 1.356 0 11-.965 2.313 1.357 1.357 0 01-.29-1.481zm50.182-5.317c0-.75.607-1.358 1.357-1.358l-.004.004a1.36 1.36 0 011.363 1.354 1.358 1.358 0 01-2.716 0zm-20.509-.176a1.36 1.36 0 011.359-1.358l-.004.002a1.364 1.364 0 011.358 1.386c-.003.021-.004.043-.005.065l.007.067v.001l.002.013a1.36 1.36 0 01-2.048 1.153 1.358 1.358 0 01-.665-1.182c.003-.022.004-.044.005-.066l-.008-.076-.001-.005zm-18.623 1.834a1.658 1.658 0 111.172-.484 1.66 1.66 0 01-1.175.486l.003-.002zm-1.357-1.658c0-.75.607-1.358 1.357-1.358l-.003.004a1.36 1.36 0 011.362 1.354 1.358 1.358 0 11-2.716 0zm29.731-5.806c0-.75.608-1.358 1.358-1.358l-.004.001a1.358 1.358 0 11-1.354 1.357zm-38.659 1.506l.181-.371c.273-.557.563-1.125.869-1.682l.199-.363.08.406a1.66 1.66 0 01-.952 1.842l-.377.168zm1.022-1.364l.005-.01-.004.001-.001.009zm0 0c-.102.193-.202.385-.3.578.146-.166.248-.364.3-.578zm17.393-.319c0-.75.608-1.358 1.358-1.358l-.003.002a1.358 1.358 0 11-1.354 1.356zm30.086-5.297c.073.258.221.488.425.661-.14-.224-.282-.444-.425-.661zm-20.378-1.236a1.356 1.356 0 011.202-.66h.005l.008.001a.395.395 0 00.059.004l.079-.009a1.357 1.357 0 11-.023 2.714h-.006c-.022-.004-.045-.005-.067-.006a1.023 1.023 0 00-.05.005l-.029.004a1.355 1.355 0 01-1.178-2.053zm-18.627 2.353a1.657 1.657 0 111.17-.485 1.657 1.657 0 01-1.173.485h.003zm-1.358-1.658a1.36 1.36 0 112.719.001 1.36 1.36 0 01-2.72-.001zm11.064-6.938a1.358 1.358 0 112.716-.002 1.358 1.358 0 01-2.716.002zm1.358-1.359z"
      fill="#fff"
    />
    <path
      d="M108.207 290.701s-8.59-4.191-11.242-2.229c-2.652 1.962-1.653 10.607 12.194 7.119 13.848-3.489-.952-4.89-.952-4.89z"
      fill="#FAC896"
    />
    <path
      d="M96.356 293.341s1.281 2.149 3.419 2.576c2.137.427 8.296-5.153 5.659-7.202-2.637-2.05-9.078 4.626-9.078 4.626z"
      fill="#F39C55"
    />
    <path
      d="M108.607 283.239s6.408-6.498 3.632-27.509c-1.536-11.614 12.423 25.417.464 29.318-11.958 3.901-4.096-1.809-4.096-1.809z"
      fill="#013BFF"
    />
    <path
      d="M106.596 246.075a2.185 2.185 0 012.524-1.346 21.999 21.999 0 0116.463 14.503c4.85 13.643 4.04 29.997-16.969 37.177-2.337.932-4.965-11.027-.883-12.319 3.59-1.135 8.899-2.71 7.214-18.765a28.506 28.506 0 00-7.036-16.064c-1.044-1.161-1.674-2.136-1.313-3.186z"
      fill="#3778F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M112.722 294.981l.062.028.062-.028a37.3 37.3 0 002.108-1.045l.061-.032.015-.068a1.657 1.657 0 10-2.308 1.145zm-.629-1.828a1.356 1.356 0 012.281-.634c.255.255.398.601.398.962a1.32 1.32 0 01-.022.225c-.681.362-1.325.681-1.964.973a1.354 1.354 0 01-.693-1.526zM111.557 282.456c.307.462.825.74 1.38.74h.002a1.655 1.655 0 00.731-3.139l-.124-.062-.072.119a7.36 7.36 0 01-1.882 2.14l-.113.085.078.117zm1.745.395a1.355 1.355 0 01-1.413-.449v-.001a7.628 7.628 0 001.767-2.009 1.358 1.358 0 01-.354 2.459zM112.038 247.517a1.652 1.652 0 001.599 1.231 1.659 1.659 0 001.624-1.992l-.014-.07-.064-.033a23.064 23.064 0 00-2.234-1.006l-.065-.026-.062.036a1.652 1.652 0 00-.784 1.86zm.344.079a1.355 1.355 0 01.528-1.645c.705.277 1.4.59 2.07.933a1.356 1.356 0 01-2.598.712zM121.878 288.622l.106.143.123-.131c.68-.709 1.314-1.46 1.898-2.249l.105-.142-.158-.08a1.65 1.65 0 00-2.074 2.459zm-.032-.986a1.36 1.36 0 011.359-1.358h.002c.152.001.302.027.444.08a22.943 22.943 0 01-1.63 1.933 1.33 1.33 0 01-.175-.655zM120.811 254.312c.055.873.78 1.553 1.655 1.55.607 0 1.166-.333 1.454-.868l.041-.075-.043-.073a22.406 22.406 0 00-1.518-2.223l-.056-.067-.084.011a1.654 1.654 0 00-1.449 1.745zm.298-.189a1.353 1.353 0 011.105-1.246c.504.655.97 1.338 1.396 2.047a1.355 1.355 0 01-2.501-.801zM121.771 265.852a1.658 1.658 0 103.317 0 1.658 1.658 0 00-3.317 0zm.301 0a1.357 1.357 0 112.714-.002 1.357 1.357 0 01-2.714.002zM121.197 276.332a1.659 1.659 0 103.064-1.271 1.659 1.659 0 00-3.064 1.271zm.175-.634a1.358 1.358 0 112.716-.002 1.358 1.358 0 01-2.716.002z"
      fill="#fff"
    />
    <path
      d="M96.02 243.882a14.226 14.226 0 01-8.804-1.546c-4.13-2.252-9.293-6.283-8.923-14.919a16.807 16.807 0 018.53-13.922c6.957-3.935 16.968-5.565 22.813-.215 8.89 8.134 8.251 21.82 3.629 25.63-3.242 2.672-12.19 4.262-17.245 4.972z"
      fill="#F97700"
    />
    <path
      d="M91.304 287.091s12.845-4.339 14.662-1.461c1.818 2.877-.527 10.89-15.985 8.958-15.457-1.932-3.853-7.792 1.323-7.497z"
      fill="#FAC896"
    />
    <path
      d="M94.175 286.157s.592-.22.615.307c.022.527.373 7.631-2.065 8.372-2.437.74-.285-8.481 1.45-8.679z"
      fill="#F39C55"
    />
    <path
      d="M100.77 257.459l-1.095.128a6.908 6.908 0 01-7.663-6.059l-.853-7.294a3.427 3.427 0 013.008-3.803l8.006-.936a3.43 3.43 0 013.804 3.008l.852 7.293a6.908 6.908 0 01-6.059 7.663z"
      fill="#FAC896"
    />
    <path
      d="M106.541 245.161l.056 1.133a2.104 2.104 0 01-1.237 2.03c-2.426 1.097-7.765 3.12-12.017 1.967a2.116 2.116 0 01-1.543-1.76l-.593-4.416a2.11 2.11 0 012.358-2.372l11.136 1.434a2.107 2.107 0 011.84 1.984z"
      fill="#F39C55"
    />
    <path
      d="M103.497 215.271c4.557 2.218 8.837 7.131 9.553 12.672 1.047 8.105 2.029 19.361-11.097 19.649-14.623.321-19.72-15.207-19.529-18.748.492-9.117 7.23-20.313 21.073-13.573z"
      fill="#FAC896"
    />
    <path
      d="M102.125 236.393c.01.003.02.004.03.005.062.006 1.541.135 2.196-.415a.86.86 0 00.32-.603c.092-1.124-1.383-2.723-1.445-2.791a.184.184 0 00-.26-.009.184.184 0 00-.01.26c.397.427 1.414 1.712 1.349 2.51a.493.493 0 01-.189.351c-.447.376-1.542.366-1.926.331a.184.184 0 00-.064.362l-.001-.001z"
      fill="#F97700"
    />
    <path
      d="M105.319 229.556a.26.26 0 01-.039-.198.266.266 0 01.112-.167c1.682-1.114 2.944-1.24 4.655-.461a.263.263 0 01-.218.479c-1.556-.708-2.602-.601-4.145.421a.26.26 0 01-.365-.074zM92.432 233.413a.263.263 0 01-.023-.371c1.333-1.518 2.52-1.968 4.372-1.66a.266.266 0 01.217.303.26.26 0 01-.303.217c-1.686-.276-2.667.097-3.89 1.488a.264.264 0 01-.373.024v-.001zM108.324 231.521a.957.957 0 100-1.914.957.957 0 000 1.914z"
      fill="#231F20"
    />
    <path
      d="M95.422 234.401a.984.984 0 100-1.968.984.984 0 000 1.968z"
      fill="#231F20"
    />
    <path
      d="M86.252 234.157l-3.278-.325a1.816 1.816 0 00-1.89 2.485c.035.077.076.153.121.225l.895 1.413a4.67 4.67 0 005.614 1.864l.54-.207-2.002-5.455zM111.496 228.346l3.073-1.18a1.773 1.773 0 012.424 2.139l-.487 1.6a4.67 4.67 0 01-4.918 3.288l-.576-.057.484-5.79z"
      fill="#FAC896"
    />
    <path
      d="M86.942 233.942c6.011-3.452 17.305-10.354 16.739-13.186-.022-.05 5.284 8.159 10.261 6.746 4.978-1.413-5.878-20.121-18.11-16.414-10.637 3.221-17.122 11.202-14.397 20.585a3.78 3.78 0 005.507 2.269zM104.867 243.32a4.071 4.071 0 01-2.967-.988.265.265 0 01-.02-.373.263.263 0 01.372-.02 3.551 3.551 0 002.614.847c.928-.153 1.748-.843 2.433-2.055a.263.263 0 01.458.259c-.769 1.359-1.715 2.136-2.81 2.316l-.08.014z"
      fill="#F97700"
    />
    <path
      d="M83.153 226.344s-11.494 4.538-13.762 8.743c-2.267 4.205 6.613 7.834 7.688 7.047 1.076-.788 5.188-12.097 7.44-12.165 2.252-.068-1.366-3.625-1.366-3.625zM109.623 219.822s11.973-3.064 16.274-.987-.762 10.223-2.094 10.216c-1.333-.007-11.296-6.756-13.16-5.491-1.864 1.265-1.02-3.738-1.02-3.738z"
      fill="#F97700"
    />
    <path
      d="M87.673 253.367s-4.51 28.192 5.468 32.463c.141.09-8.117-1.007-8.82-6.14-.702-5.134.115-21.605 3.352-26.323z"
      fill="#013BFF"
    />
    <path
      d="M111.14 301.725a8.612 8.612 0 015.21-.666c1.829.315 4.587.484 5.626-1.063 1.614-2.401 3.953-9.148 6.171-8.214 2.219.934.647 16.508-2.018 19.337-2.664 2.829-12.929.413-13.636-.053-.618-.407-7.477-6.382-1.353-9.341z"
      fill="#55312F"
    />
    <path
      d="M75.506 293.527s34.562 7.619 44.403 7.033l-1.124 11.658s-24.365 5.225-41.39 2.559l-1.89-21.25z"
      fill="#129F72"
    />
    <path
      d="M87.916 250.724a2.689 2.689 0 00-4.216-2.642c-5.03 3.647-12.02 10.94-12.838 23.638-1.215 18.894 11.018 23.682 19.259 23.811a2.654 2.654 0 002.383-1.441c1.422-2.722 3.525-8.556-2.074-10.099-3.47-.792-7.32-5.401-4.43-22.16l1.916-11.107z"
      fill="#3778F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81.53 249.923a1.66 1.66 0 01-.254-.025l-.321-.05.247-.212a31.99 31.99 0 011.736-1.391l.261-.196-.022.326a1.658 1.658 0 01-1.645 1.548h-.002zm.16-.309c.363-.304.73-.598 1.11-.89h.003a1.358 1.358 0 01-1.112.89z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.03 283.146l181.667-54.652 132.797 69.99a3.648 3.648 0 01.87 5.666c-13.876 14.642-68.419 70.603-95.238 74.564-12.148 1.155-61.179-33.071-134.379-46.471-8.076-.775-68.681-27.492-86.69-44.521a2.74 2.74 0 01.973-4.576z"
      fill="#1ABD7D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M271.544 302.936s33.443-9.283 65.642 9.686h.004c32.197 13.7 41.447 12.105 41.447 12.105v43.401s-37.239-11.973-53.962-19.088c-14.017-5.963-54.554-12.949-56.689-11.158-2.135 1.79 0-34.009 0-34.009l3.558-.937z"
      fill="#68DCAF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M267.037 297.258s-8.11-13.17-41.704-21.386c-14.974-4.704-57.834-34.37-57.834-34.37v43.621a8.777 8.777 0 004.363 7.589c10.175 5.918 35.62 20.196 48.967 23.012 12.367 3.22 46.865 20.638 46.865 20.638l-.657-39.104z"
      fill="#68DCAF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.499 241.5s98.016-53.243 105.394-59.918c7.378-6.675 74.829 33.023 71.667 40.754-3.162 7.731-94.48 62.157-94.48 62.157s-53.071-12.231-82.581-42.993z"
      fill="#fff"
    />
    <path
      d="M376.471 336.735c-11.327 0-89.841-29.292-93.279-30.576l.246-.658c.866.324 86.638 32.323 93.707 30.468l.179.679c-.28.064-.566.094-.853.087zM376.251 346.229c-7.862 0-83.552-24.618-92.45-27.521l.218-.668c35.796 11.68 89.95 28.646 92.433 27.5l.381.59a1.153 1.153 0 01-.582.099zM376.311 349.971c-2.617 0-11.419-1.771-43.248-12.05-20.985-6.778-41.925-14.022-42.135-14.094l.23-.663c33.278 11.518 83.594 27.946 85.809 25.999l.533.458c-.122.144-.297.35-1.189.35zM376.169 360.574c-10.945 0-78.994-25.585-87.107-28.651l.248-.657c33.443 12.637 84.401 30.654 87.731 28.489l.383.59a2.468 2.468 0 01-1.255.229zM254.429 292.858c-25.071-1.16-86.551-38.945-87.169-39.327l.368-.598c.619.38 61.941 38.072 86.833 39.223l-.032.702zM248.982 296.074c-16.381 0-78.81-36.447-81.497-38.018l.354-.607c.664.389 66.593 38.885 81.716 37.905l.044.701a9.395 9.395 0 01-.617.019zM247.287 303.019c-12.063 0-77.406-32.484-80.243-33.896l.313-.629c.709.352 71.016 35.302 80.565 33.78l.113.694a4.687 4.687 0 01-.748.051zM243.78 309.698c-14.374 0-73.999-29.355-76.54-30.61l.31-.629c.624.307 62.518 30.756 76.393 30.535l.013.703-.176.001zM240.839 316.172c-10.625 0-70.755-30.073-73.334-31.366l.315-.628c.635.318 63.715 31.876 73.274 31.284l.044.701a4.069 4.069 0 01-.299.009z"
      fill="#C6DDFF"
    />
    <path
      d="M185.145 231.862l-8.806 4.819s55.422 37.87 62.726 40.349c7.303 2.478-52.61-44.331-53.92-45.168z"
      fill="#DFCCC3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M377.232 324.728c.018-.013 86.778-62.346 89.584-61.641.703.354.703 38.293 0 40.755-.702 2.461-53.047 54.803-89.583 64.289.35-.367 0-43.385 0-43.4l-.001-.003z"
      fill="#68DCAF"
    />
    <path
      d="M330.156 199.398c-21.43-9.588-36.887-37.488-49.832-40.65-3.808-.93-15.051 2.885-29.049 9.007a550.088 550.088 0 00-57.843 29.957c-14.81 8.914-25.59 16.807-25.934 20.345-1.054 10.827 82.581 66.436 82.581 66.436 5.501 2.426 98.696-65.32 100.453-66.436 1.757-1.117 1.054-9.071-20.376-18.659z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M354.749 218.057s111.647 37.662 112.068 45.031c.422 7.368-86.707 64.995-89.551 66.047-2.844 1.052-99.985-33.589-119.92-37.522-19.935-3.933 93.187-71.512 97.403-73.556z"
      fill="#fff"
    />
    <path
      d="M267.497 266.451c-5.415-5.811-56.27-49.994-56.783-50.439l.46-.531c.514.445 51.397 44.653 56.836 50.492l-.513.478zM277.98 255.966c-4.81-6.323-51.014-55.348-51.48-55.842l.511-.482c.467.495 46.696 49.547 51.528 55.898l-.559.426zM293.705 247.571c-4.81-6.322-51.014-55.348-51.48-55.842l.511-.481c.467.494 46.696 49.546 51.528 55.897l-.559.426zM314.657 234.304c-4.809-6.321-51.013-55.346-51.48-55.841l.512-.482c.466.495 46.695 49.547 51.528 55.898l-.56.425zM329.02 224.297c-4.811-6.322-51.014-55.347-51.48-55.842l.511-.481c.466.495 46.696 49.546 51.527 55.898l-.558.425zM383.592 311.615c-6.119-4.184-78.352-29.421-79.08-29.676l.231-.663c2.979 1.04 73.05 25.521 79.246 29.758l-.397.581zM393.114 303.755c-4.655-6.099-57.646-29.589-58.181-29.827l.284-.642c2.193.97 53.692 23.801 58.456 30.043l-.559.426zM410.074 289.308c-1.839-1.111-56.104-27.86-56.652-28.13l.311-.63c2.237 1.103 54.839 27.032 56.704 28.158l-.363.602zM425.388 281.741c-.994-2.392-36.162-21.085-59.558-33.066l.32-.625c5.981 3.063 58.473 30.018 59.888 33.421l-.65.27zM444.879 266.432c-2.361-2.932-52.711-21.254-79.005-30.532l.233-.664c3.112 1.099 76.247 26.936 79.317 30.756l-.545.44z"
      fill="#1ABD7D"
    />
    <path
      d="M377.81 336.729l-.219-.668c25.282-8.315 88.781-64.962 89.42-65.533l.469.524c-.64.569-64.248 57.313-89.67 65.677zM377.81 345.302l-.219-.667c25.282-8.315 88.78-64.962 89.419-65.534l.469.524c-.64.573-64.247 57.317-89.669 65.677z"
      fill="#fff"
    />
    <path
      d="M377.81 349.402l-.219-.667c25.282-8.315 88.78-64.962 89.419-65.533l.469.523c-.64.573-64.247 57.317-89.669 65.677zM377.81 359.601l-.219-.667c25.282-8.316 88.78-64.962 89.419-65.533l.469.523c-.64.572-64.247 57.316-89.669 65.677z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M377.265 329.135s88.535-65.96 88.675-66.673c.139-.713 2.32 1.168-1.006 4.453-3.325 3.285-20.564 17.745-27.979 22.795-7.416 5.051-55.265 37.933-59.69 39.425z"
      fill="#1ABD7D"
    />
    <path
      d="M167.499 241.682a.087.087 0 01.046-.082.09.09 0 01.095.006c2.957 2.196 52.014 38.305 84.881 42.388 4.774.85-46.453-3.498-81.917-35.267a9.425 9.425 0 01-3.104-7.022l-.001-.023z"
      fill="#1ABD7D"
    />
    <path
      d="M331.127 294.955c28.058 0 50.803-3.062 50.803-6.84s-22.745-6.841-50.803-6.841c-28.057 0-50.802 3.063-50.802 6.841s22.745 6.84 50.802 6.84z"
      fill="#DFCCC3"
    />
    <path
      d="M265.11 379.898c7.888 0 14.282-.707 14.282-1.58 0-.873-6.394-1.581-14.282-1.581s-14.283.708-14.283 1.581 6.395 1.58 14.283 1.58z"
      fill="#499D75"
    />
    <path
      d="M218.09 352.888s18.019-35.442 21.589-39.676c3.71-4.399 19.506-.745 17.42 7.128-2.057 7.757-18.381 28.495-32.757 34.938-4.439 2.586-6.763-1.258-6.252-2.39zM270.121 371.624s-3.112-40.188-1.349-45.74c1.788-5.621 18.313-10.348 19.827-2.199 1.353 7.281-1.677 34.256-11.453 47-2.701 4.467-6.89 2.192-7.025.939z"
      fill="#FAC896"
    />
    <path
      d="M223.483 353.869a20.47 20.47 0 00-8.994-3.734c-3.948-.618-9.238-1.483-10.015-1.816-1.262-.541-9.989-1.661-2.439 3.585 7.549 5.246 18.054 10.908 19.896 10.118 1.842-.79 2.375-5.913 3.263-6.343.345-.165-.521-.932-1.711-1.81zM272.426 369.51a12.496 12.496 0 00-5.26.427c-3.761 1.14-10.584 3.173-11.58 3.216-1.387.06-9.707 2.811-.438 4.233 9.269 1.421 21.374 1.954 22.634.462 1.26-1.491-.746-6.274-.163-7.038.359-.47-2.75-.979-5.193-1.3z"
      fill="#1ABD7D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M268.232 335.366s17.778 12.055 18.114 13.07c-.014.088 1.894-9.193 1.335-9.613-.559-.419-19.449-3.457-19.449-3.457z"
      fill="#F39C55"
    />
    <path
      d="M371.305 255.472a5.615 5.615 0 00-5.523-4.398c-16.493.118-75.504.602-78.284 1.498-3.234 1.041-15.541 5.49-24.827 16.443-9.286 10.954 2.147 21.136 24.521 22.44 22.374 1.304 69.215 3.317 79.467-9.792 7.063-9.029 5.995-20.147 4.646-26.191z"
      fill="#E52822"
    />
    <path
      d="M263.56 268.413s-27.286 35.313-32.15 42.882c-4.864 7.569-8.432 10.796 3.941 13.008 12.372 2.212 52.037 20.187 56.681 16.611 4.644-3.575 3.815-69.126-4.745-71.33-8.561-2.205-16.502-6.842-23.727-1.171z"
      fill="#E52822"
    />
    <path
      d="M283.134 291.64c4.216.301 8.832.587 10.613.291 0-.021.885 12.69.885 12.69s-2.987-6.839-11.973-11.124a.975.975 0 01.475-1.857zM333.93 252.932c-.506 1.834 40.723 6.334 36.047-1.889 0 0-13.235-.659-36.047.348a9.22 9.22 0 010 1.541z"
      fill="#B01F1A"
    />
    <path
      d="M325.323 217.314s9.31-49.711 31.969-37.415c22.66 12.296 17.039 69.559 16.512 71.492-.528 1.932-36.01 3.688-39.874 0-3.865-3.689-8.872-32.791-8.607-34.077z"
      fill="#129F72"
    />
    <path
      d="M342.424 244.142a22.176 22.176 0 003.491-4.09 19.616 19.616 0 003.241-9.115c.099-1.033.177-2.094.266-3.129 0 0-9.915 15.983-18.101 18.136.043.135 6.205 1.48 11.103-1.802z"
      fill="#037A4A"
    />
    <path
      d="M209.92 366.575c7.519 0 13.613-.598 13.613-1.336 0-.739-6.094-1.337-13.613-1.337-7.518 0-13.613.598-13.613 1.337 0 .738 6.095 1.336 13.613 1.336z"
      fill="#499D75"
    />
    <path
      d="M340.759 161.116h.787a8.51 8.51 0 018.509 8.51v14.012a8.51 8.51 0 01-8.509 8.508h-.787a8.51 8.51 0 01-8.509-8.508v-14.012c0-4.7 3.81-8.51 8.509-8.51z"
      fill="#FAC896"
    />
    <path
      d="M340.97 167.881a.42.42 0 01.573.579l-8.327 13.854c-.428.422-.937.222-.966-.379l.067-8.985 8.653-5.069z"
      fill="#F39C55"
    />
    <path
      d="M345.874 159.963c3.344-10.644-.564-21.352-8.728-23.917-8.165-2.565-17.495 3.984-20.839 14.627-3.344 10.644.564 21.352 8.729 23.917 8.165 2.565 17.494-3.984 20.838-14.627z"
      fill="#FAC896"
    />
    <path
      d="M349.978 195.456c.624-8.278-6.928-14.72-14.926-12.499-3.941 1.095-8.299 3.72-11.999 9.384-9.485 14.521-9.881 20.845-8.278 22.133 1.603 1.287 17.295 7.792 19.872 8.229 1.932.327 14.336-14.071 15.331-27.247zM290.247 219.259l-24.652-2.265a2.98 2.98 0 00-2.776 4.578l12.558 19.496a2.977 2.977 0 002.503 1.365h14.117a2.98 2.98 0 002.957-3.325l-2.024-17.23a2.98 2.98 0 00-2.683-2.619z"
      fill="#129F72"
    />
    <path
      d="M276.256 242.432l15.538-30.46a7.705 7.705 0 016.863-4.203h41.654l-17.45 34.663h-46.605z"
      fill="#037A4A"
    />
    <path
      d="M331.671 207.923a12.044 12.044 0 00-6.504 9.786c-.326 3.879-1.267 8.512-3.885 8.915-4.567.702-25.821 10.714-28.807 10.012-2.986-.702-8.386-3.747-11.243-1.054-2.857 2.694-4.919 8.608-1.932 9.662 2.987 1.054 5.269 2.108 10.363 1.932 5.094-.176 45.649 1.932 51.105-4.743 5.456-6.675 9.663-15.544 10.371-20.42.623-4.286-5.162-21.318-19.468-14.09z"
      fill="#FAC896"
    />
    <path
      d="M345.328 228.414a7.026 7.026 0 008.007-5.837c1.085-6.964 2.51-18.737 1.63-28.317-.762-8.301-3.255-14.953-9.2-15.402-6.914-.363-23.076 34.969-22.901 36.888.148 1.618 10.291 10.856 22.464 12.668z"
      fill="#129F72"
    />
    <path
      d="M340.441 182.515s-14.357 12.27-19.299 25.254h4.867s10.601-23.035 14.432-25.254zM347.898 177.657s-2.612 1.18-4.144 1.879c-1.532.7.225 15.163 9.268 22.892 9.044 7.729 12.648 10.271 14.141 14.138 1.492 3.868 2.898 12.319 6.938 12.747 4.04.428-4.246-42.968-26.203-51.656z"
      fill="#037A4A"
    />
    <path
      d="M317.536 148.048a2.933 2.933 0 01-1.79.311c-3.183-.406-10.737-2.381-4.692-12.001 1.582-2.248 6.516-2.611 10.219-2.145 3.703.466 21.041-10.14 30.443.126 9.402 10.265 8.094 19.367 17.486 23.553 9.393 4.186 15.122 16.482 15.156 26.319.034 9.837 5.453 20.116 9.176 24.284 3.724 4.167 7.864 18.221-3.691 22.26-11.555 4.04-17.932-2.226-18.739-9.939-.808-7.714-8.142-15.009-13.851-18.213-5.709-3.205-11.948-12.778-11.499-22.701.45-9.924 2.057-11.725-3.035-13.394-5.092-1.668-.15-2.947 1.177-8.657 1.327-5.709-4.909-5.396-5.129 1.672-.264 2.371.588-3.231-1.726-4.405-2.314-1.173-2.682 1.775-11.127-6.089-2.661-2.022-6.822-1.842-8.378-.981z"
      fill="#F97700"
    />
    <path
      d="M327.748 160.802a.217.217 0 10-.218-.217c0 .12.098.217.218.217zM326.877 161.654a.217.217 0 10-.218-.217c0 .12.098.217.218.217zM326.128 160.571a.217.217 0 100-.435.217.217 0 000 .435zM325.025 161.325a.218.218 0 100-.435.218.218 0 000 .435z"
      fill="#F97700"
    />
    <path
      d="M320.409 159.022a.863.863 0 10.001-1.725.863.863 0 00-.001 1.725z"
      fill="#231F20"
    />
    <path
      d="M315.545 157.487s-2.351 6.154-2.038 7.376c.314 1.222 2.297 1.607 3.261 1.276.963-.33-1.223-8.652-1.223-8.652z"
      fill="#FAC896"
    />
    <path
      d="M319.547 167.614s5.265-1.273 5.478-1.36c.214-.088-1.246 6.894-5.478 1.36z"
      fill="#F74000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M316.002 158.609c0 2.651 1.816 4.808 4.047 4.808 2.234 0 4.048-2.157 4.048-4.808s-1.816-4.808-4.048-4.808-4.047 2.156-4.047 4.808zm.704-.002c0-2.262 1.5-4.104 3.343-4.104 1.846 0 3.343 1.842 3.343 4.104s-1.499 4.103-3.343 4.103c-1.843 0-3.343-1.841-3.343-4.103z"
      fill="#fff"
    />
    <path
      d="M323.502 157.376a.352.352 0 01-.042-.7l17.862-2.181a.345.345 0 01.393.306.35.35 0 01-.306.394l-17.862 2.181a.338.338 0 01-.045 0z"
      fill="#fff"
    />
    <path
      d="M322.296 152.859a.264.264 0 01-.224-.121c-.642-1.006-1.332-1.518-2.048-1.518h-.003c-1.237 0-2.223 1.504-2.233 1.518a.264.264 0 01-.443-.285c.046-.072 1.149-1.76 2.676-1.76.908 0 1.748.593 2.493 1.76a.264.264 0 01-.221.406h.003z"
      fill="#231F20"
    />
    <path
      d="M203.731 195.129s13.944 4.133 17.17 3.419c3.144.265-.896 14.424-20.555 6.258-6.461-1.631-8.763-9.878 3.385-9.677zM246.536 174.628s-9.44 11.064-12.536 12.223c-2.491 1.936 8.612 11.606 20.645-5.954 4.528-4.887 1.966-13.058-8.109-6.269z"
      fill="#F4BA7F"
    />
    <path
      d="M207.198 196.247s1.861-.303 6.109 1.256c2.423.889-1.76 12.564-5.296 8.64-3.536-3.923-4.854-7.876-.813-9.896zM247.136 176.868s-2.698-.206-7.269 5.059c-1.692 1.951 6.668 8.409 10.562 4.121 4.348-4.784 1.97-8.886-3.293-9.18z"
      fill="#F39C55"
    />
    <path
      d="M193.036 197.709a550.467 550.467 0 0157.843-29.957c.861-.376 1.312-.886 2.151-1.244-8.025-8.989-13.072-12.246-27.649-14.116-16.37-2.1-31.729 9.609-36.471 18.119a26.611 26.611 0 001.892 28.556c.734-.448 1.479-.9 2.234-1.358z"
      fill="#E62822"
    />
    <path
      d="M199.251 139.091s-12.788-1.054-9.89-14.492c1.493-6.851 6.198-6.521 8.868-8.87 2.669-2.35 8.521-10.364 18.622-8.783 10.1 1.581 30.564 20.578 9.661 31.104-8.783 3.939-27.261 1.041-27.261 1.041z"
      fill="#55312F"
    />
    <path
      d="M215.933 161.947l-1.096.128a6.908 6.908 0 01-7.663-6.059l-.852-7.294a3.433 3.433 0 01.716-2.525 3.433 3.433 0 012.292-1.279l8.006-.935a3.43 3.43 0 013.804 3.008l.852 7.293a6.908 6.908 0 01-6.059 7.663z"
      fill="#F4BA7F"
    />
    <path
      d="M221.704 149.649l.056 1.133c.045.868-.55 2.086-.951 2.857-1.88 3.612-7.649 4.135-12.302 1.141-.715-.46-1.429-.917-1.542-1.76l-.593-4.416a2.11 2.11 0 012.358-2.372l11.136 1.434a2.11 2.11 0 011.838 1.983z"
      fill="#F39C55"
    />
    <path
      d="M223.429 122.553c3.494 3.672 5.785 9.772 4.518 15.212-1.855 7.96-4.87 18.849-17.267 14.528-13.812-4.813-13.154-21.144-11.739-24.396 3.649-8.367 13.876-16.5 24.488-5.344z"
      fill="#F4BA7F"
    />
    <path
      d="M214.864 141.327l.029.009c.062.014 1.51.337 2.232-.118a.856.856 0 00.397-.554c.242-1.101-1.004-2.884-1.057-2.96a.184.184 0 00-.319.027.184.184 0 00.018.185c.337.477 1.172 1.886.999 2.668a.497.497 0 01-.235.323c-.493.312-1.574.156-1.953.07a.184.184 0 00-.112.349l.001.001z"
      fill="#F97700"
    />
    <path
      d="M220.35 134.978a.26.26 0 01.122-.351c1.816-.88 3.084-.835 4.674.166a.264.264 0 11-.281.446c-1.447-.91-2.497-.945-4.163-.138a.263.263 0 01-.352-.122v-.001zM205.659 137.076a.263.263 0 01.026-.372c1.524-1.323 2.761-1.61 4.553-1.059.139.043.217.19.174.329a.26.26 0 01-.329.175c-1.633-.501-2.657-.261-4.055.955a.264.264 0 01-.372-.027l.003-.001zM222.894 137.836a.956.956 0 10.002-1.912.956.956 0 00-.002 1.912zM208.306 139.034a.984.984 0 10-.001-1.967.984.984 0 00.001 1.967z"
      fill="#231F20"
    />
    <path
      d="M201.551 136.863c6.421-2.616 18.538-7.943 18.355-10.824-.014-.056 4.144 8.792 9.267 8.057 5.123-.734-3.132-20.726-15.751-18.693-10.972 1.768-18.468 8.81-17.022 18.473a3.777 3.777 0 005.151 2.987z"
      fill="#55312F"
    />
    <path
      d="M200.839 136.985l-3.204-.761a1.817 1.817 0 00-2.207 2.209c.025.081.055.16.09.236l.698 1.521a4.67 4.67 0 005.313 2.6l.562-.133-1.252-5.672zM226.634 134.606l3.204-.76a1.814 1.814 0 012.206 2.21c-.025.08-.055.159-.09.236l-.698 1.517a4.668 4.668 0 01-5.313 2.599l-.562-.132 1.253-5.67z"
      fill="#F4BA7F"
    />
    <path
      d="M213.264 146.389s6.203-.492 6.542.181c.34.674-3.706 6.385-6.542-.181z"
      fill="#F97700"
    />
    <path
      d="M225.73 160.091c6.222 5.264 9.242 10.27 11.531 13.924 1.695-.812 4.117-2.023 5.772-2.794-7.447-8.831-23.712-16.551-17.303-11.13zM200.093 193.797c1.282-.733 2.58-1.469 3.896-2.206-4.466-6.65-3.565-17.964-2.708-23.432.146-.936-1.037-2.788-1.707-1.953-5.26 6.553-3.035 20.271-1.922 24.695a4.976 4.976 0 002.441 2.896z"
      fill="#B01F1A"
    />
    <path
      d="M201.697 164.252a2.687 2.687 0 00-4.216-2.642c-5.03 3.646-12.02 10.939-12.837 23.638-1.215 18.893 15.839 22.104 24.082 22.234a2.656 2.656 0 002.384-1.442c1.42-2.721 3.523-8.555-2.076-10.098-3.469-.792-12.142-3.823-9.252-20.583l1.915-11.107zM223.902 158.515c-1.779-1.415-.81-4.374 1.533-4.653 6.052-.72 14.619-.138 24.34 8.347 13.46 11.748 6.408 18.663.281 24.177a2.68 2.68 0 01-2.69.543c-2.591-.937-7.337-3.429-5.213-7.683a4.338 4.338 0 00.511-2.442c-.281-2.319-2.186-2.923-7.584-8.563a70.271 70.271 0 00-7.019-6.419l-4.159-3.307z"
      fill="#E62822"
    />
    <path
      d="M149.576 369.71c11.897 0 21.542-2.438 21.542-5.446 0-3.007-9.645-5.445-21.542-5.445-11.897 0-21.541 2.438-21.541 5.445 0 3.008 9.644 5.446 21.541 5.446z"
      fill="#499D75"
    />
    <path
      d="M149.203 366.576c14.728 0 26.667-11.384 26.667-25.427 0-14.042-11.939-25.426-26.667-25.426-14.727 0-26.666 11.384-26.666 25.426 0 14.043 11.939 25.427 26.666 25.427z"
      fill="#3478F6"
    />
    <path
      d="M143.717 316.262s10.313 7.389 10.752 13.097c.439 5.708 16.299-3.238 16.299-3.238s-5.22-7.374-14.317-9.444c-3.902-.754-5.39-1.481-12.734-.415z"
      fill="#EF4923"
    />
    <path
      d="M169.561 324.729s-10.523 1.118-15.091 4.631c-4.567 3.512 7.546 34.08 7.546 34.08s13.863-6.763 13.828-21.256c.004-3.421-.151-10.932-6.283-17.455z"
      fill="#1ABD7D"
    />
    <path
      d="M154.471 329.36s-18.971-3.539-31.267 17.465c.056.217 2.481 12.076 13.975 17.023.352.166 18.345-26.496 17.292-34.488z"
      fill="#F97700"
    />
    <path
      d="M162.993 362.915s4.74-26.529-8.522-33.556c0 0 2.657 4.774-17.292 34.489.003 0 12.555 6.539 25.814-.933z"
      fill="#FCBC2E"
    />
    <path
      d="M246.544 394.307h33.78v30.97a2.81 2.81 0 01-2.811 2.81h-30.969v-33.78z"
      fill="#74F4C3"
    />
    <path
      d="M246.544 394.307l-12.179-7.982h34.751a2.81 2.81 0 011.728.594l9.48 7.391h-33.78v-.003z"
      fill="#1ABD7D"
    />
    <path
      d="M246.544 428.087l-10.93-7.305a2.812 2.812 0 01-1.249-2.336v-32.124l12.179 7.982v33.783z"
      fill="#499D75"
    />
    <path
      d="M293.446 390.315l42.86-3.992v28.532l-39.768 3.328a2.108 2.108 0 01-2.283-2.035l-.809-25.833z"
      fill="#1ABD7D"
    />
    <path
      d="M346.492 375.294l-10.186 11.028v28.532l9.531-9.038a2.11 2.11 0 00.657-1.529l-.002-28.993z"
      fill="#74F4C3"
    />
    <path
      d="M346.492 375.294l-10.188 11.028-42.86 3.992 13.888-11.568a2.118 2.118 0 011.185-.482l37.975-2.97z"
      fill="#499D75"
    />
  </svg>
);

export default TeacherIllustration;
